import React from "react";
import { FaCamera, FaFacebookF, FaTwitter } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";

const Behind = () => {
  return (
    <div className=" bg-base-200  mt-10 mb-5 w-full">
      <div className=" grid sm:grid-cols-1 lg:grid-cols-2 ">
        <img
          src="https://static.wixstatic.com/media/d33a44_95ead22b05b24c04bfca3d7e65fd2cdc~mv2.jpeg/v1/crop/x_200,y_0,w_677,h_720/fill/w_456,h_486,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/curtis%20%26%20cash%20photographer%20shoot%20(13).jpeg"
          alt=""
          className="rounded-lg shadow-sm "
        />

        <div className="ms-[-80px]">
          <h1 className="text-2xl text-gray-600 font-bold">Who is Behind?</h1>
          <p className="font-serif">
            Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
            Integer posuere erat a ante venenatis dapibus posuere velit aliquet.
            Maecenas sed diam eget risus varius blandit sit amet non magna.
            Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula
            porta felis euismod semper. Nullam id dolor id nibh ultricies
            vehicula ut id elit, fusce dapibus, tellus ac cursus commodo. Cras
            mattis consectetur purus sit amet fermentum. Vestibulum id ligula.
          </p>
          <div className=" border-s-green-400 border-4 mt-2 mb-2">
            <p className="ms-4 bg-slate-100 font-serif text-xl mt-2 mb-2">
              Pellentesque non diam et tortor dignissim bibendum. Neque sit amet
              mauris egestas quis mattis velit fringilla. Curabitur viver justo
              sed scelerisque. Cras mattis consectetur purus sit amet fermentum.
            </p>
          </div>
          <p className="font-serif">
            Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
            Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum
            dolor sit amet, consectetur adipiscing elit
          </p>
          <h1 className="text-xl text-gray-600 font-bold mt-3 mb-3">
            Elsewhere
          </h1>
          <div className="flex mb-4">
            <FaFacebookF className="text-xl font-bold me-3" />
            <FaTwitter className="text-xl font-bold me-3" />
            <FaCamera className="text-xl font-bold me-3" />

            <AiFillLinkedin className="text-xl font-bold me-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Behind;
